import React, { useEffect, useState } from 'react';

import { isDesktopApp } from '@/api/desktopSync';

export default function DesktopLocalRuntimeNotice() {
  const desktop = window.lvbDesktop;
  const [status, setStatus] = useState(desktop?.localRuntimeStatus || null);

  useEffect(() => {
    if (typeof desktop?.onLocalRuntimeStatusChanged !== 'function') return undefined;
    return desktop.onLocalRuntimeStatusChanged(setStatus);
  }, [desktop]);

  if (!isDesktopApp() || !['starting', 'recovering', 'unavailable', 'rebuild_required'].includes(status?.state)) {
    return null;
  }
  let detail = 'Offline services are still preparing on this computer.';
  if (status.state === 'recovering') detail = 'The desktop is checking and restarting offline services in one recovery attempt.';
  if (status.state === 'unavailable') detail = 'Offline services are unavailable. Online work may continue; an administrator can retry from Settings → Devices.';
  if (status.state === 'unavailable' && status.reason === 'local_process_stop_unconfirmed') {
    detail = 'Stopping offline services could not be confirmed, so restart is paused. Online work may continue; an administrator can retry from Settings → Devices.';
  }
  if (status.state === 'rebuild_required') detail = 'Offline services require administrator recovery in Settings → Devices.';

  return (
    <div
      className={`px-3 py-2 text-white text-xs font-medium flex-shrink-0 ${
        ['unavailable', 'rebuild_required'].includes(status.state) ? 'bg-red-800' : 'bg-amber-700'
      }`}
      data-testid="desktop-local-runtime-notice"
    >
      {detail}
    </div>
  );
}
